<template>
	<div class="p-col-12 p-grid">
		<div v-if="!commonService.isMobile()" class="p-col-12 p-lg-6" style="margin: auto; margin-top: 10px">
			<div class="card card-w-title" style="width: 100%;">
				<Toast />
				<div class="p-grid">
					<img :src="commonService.getHomePlayer3ImageUrl()" alt="" style="width: 100%">
				</div>
			</div>
		</div>

		<div class="p-col-12 p-lg-6" :class="[commonService.isMobile() ? 'text-box-mobile' : 'text-box']">
			<p>MAXIMIZING OPPORTUNITIES WITH TIROLIBRE.</p>
			<p class="login-subtitle">Strategic Representation</p>
			<p v-if="!commonService.isMobile()" class="login-text justified">Our digital platform is the ultimate solution for soccer players to take control of their careers with ease and precision.</p>
			<p v-if="!commonService.isMobile()" class="login-text justified">With digital tools, players can manage their personal brand, track progress, and seize opportunities. By creating a strong professional network, players can expand their reach, connect with industry professionals, and uncover new opportunities.</p>
			<p v-if="!commonService.isMobile()" class="login-text justified">Our platform showcases players' skills and achievements to agents, scouts, and team managers, boosting their visibility and increasing their chances of success.</p>
			<p v-if="commonService.isMobile()" class="login-text justified">Empower your football career with our Platform's Strategic Representation</p>
			<p v-if="commonService.isMobile()" class="login-text justified">Get real-time updates on club presentations and feedback, plus full-season support even during tough times and transfer windows.</p>
			<p v-if="commonService.isMobile()" class="login-text justified">Connect with industry pros, showcase your skills, and boost your chances of success.</p>
			<div v-if="!commonService.isMobile()" :class="isSmallScreen()? 'p-col-5 button-box' : 'p-lg-3 button-box'" style="padding: 0px">
				<Button label="Put yourself out there" class="p-button-warning" style="color: white; font-weight: bold;" @click="toLogin" />
			</div>
		</div>

		<div v-if="commonService.isMobile()" class="p-col-12 p-lg-6" style="margin: auto">
			<div class="card card-w-title" style="width: 100%;">
				<Toast />
				<div class="p-grid">
					<img :src="commonService.getHomePlayer3ImageUrl()" alt="" style="width: 100%">
				</div>
			</div>
			<div v-if="commonService.isMobile()" class="p-col-6 button-box-mobile" style="margin-top: -30px; margin-bottom: 30px">
				<Button label="Put yourself out there" class="p-button-warning" style="color: white; font-weight: bold;" @click="toLogin" />
			</div>
		</div>
	</div>

</template>

<script>
import CommonService from "@/service/CommonService";

export default {
	commonService: null,
	created() {
		this.commonService = new CommonService();
	},
	methods: {
		toLogin() {
			this.$router.push("/login");
		},
		isSmallScreen() {
			return screen.width <= 1600 ? true : false;
		},
	},
};
</script>

<style scoped>
.justified {
	text-align: justify;
	text-justify: inter-word;
}

.login-title {
	margin-top: -15px;
	font-size: 65px;
	font-weight: bold;
}

.login-subtitle {
	margin-top: -10px;
	font-size: xx-large;
	font-weight: bold;
}

.login-text {
	margin-top: 10px;
	font-size: 19px;
}

.text-box {
	margin: auto;
	padding-left: 50px;
}

.text-box-mobile {
	margin: auto;
}

.button-box {
	margin-top: 20px;
}

.button-box-mobile {
	margin: auto;
}

@media (min-width: 0px) and (max-width: 1000px) {
	.login-title {
		margin-top: -15px;
		font-size: 45px;
		font-weight: bold;
	}

	.login-subtitle {
		margin-top: -0px;
		font-size: x-large;
		font-weight: bold;
	}

	.login-text {
		margin-top: 10px;
		font-size: 16px;
	}
}
</style>